import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

/**
 * Signed percentage change against the previous window. Null when either side is missing
 * (board-level margin hidden) or the previous value was zero — growth from nothing is
 * infinite rather than a percentage, so the caller renders no chip at all.
 */
export function getPeriodChangePercentage(
  current: number | Nullish,
  previous: number | Nullish
): number | null {
  if (isNil(current) || isNil(previous) || previous === 0) {
    return null;
  }

  return ((current - previous) / previous) * 100;
}
